import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import { getCurrentSessionData } from 'utils/aws/cognito';
import { toBase64Utf8 } from 'utils/strings';

function AuthGuard({ children }) {
  const { decodeAccessToken } = getCurrentSessionData();

  if (decodeAccessToken === null || decodeAccessToken?.exp * 1000 < Date.now()) {
    const {
      hash = '',
      pathname,
      search = '',
    } = window.location;
    // `Buffer` es una global de Node y no existe en el navegador (lanzaba
    // ReferenceError). toBase64Utf8() usa btoa() y soporta Unicode.
    // Decodificación + validación anti open-redirect en SignIn.
    const redirect = toBase64Utf8(`${pathname}${search}${hash}`);

    return (<Redirect
      to={`/auth/login?redirect=${redirect}`}
    />);
  }

  return children;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default AuthGuard;
